// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../shared/font/gteestiprodisplay_regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../shared/font/gteestiprodisplay_bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../shared/font/gteestiprodisplay_light.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "GteDisplayBold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-style: normal;
  font-weight: normal;
}
@font-face {
  font-family: "GteDisplayExtra";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-style: normal;
  font-weight: normal;
}
@font-face {
  font-family: "GteDisplayLight";
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
  font-weight: normal;
}
.profile_header__h\\+b97 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 60px;
}
.profile_header__h\\+b97 h4 {
  font-family: GteDisplayExtra;
  font-size: 28px;
  color: #000000;
}

.profile_profile__Evbmz {
  margin-top: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.profile_profile__Evbmz .profile_left__DlP-w {
  display: flex;
  align-items: center;
}
.profile_profile__Evbmz .profile_left__DlP-w img {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}
.profile_profile__Evbmz .profile_nameWrapper__hN6iH {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  grid-gap: 4px;
  margin-left: 12px;
}
.profile_profile__Evbmz .profile_nameWrapper__hN6iH h4 {
  font-family: GteDisplayBold;
  font-size: 18px;
  color: #000;
}
.profile_profile__Evbmz .profile_nameWrapper__hN6iH span {
  color: #C2C2C2;
  font-size: 16px;
  font-family: GteDisplayLight;
}

.profile_slider__JVmwm {
  margin-top: 25px;
}
.profile_slider__JVmwm h4 {
  font-family: GteDisplayBold;
  font-size: 20px;
  color: #000;
  margin-bottom: 10px;
}
.profile_slider__JVmwm .profile_card__XIV0V {
  max-width: 104px;
  width: 100%;
  background: #FAFAFA;
  height: 122px;
  border-radius: 10px;
  padding: 10px;
  cursor: pointer;
}
.profile_slider__JVmwm .profile_card__XIV0V.profile_choosen__lUFuU {
  background: #9E4BFF !important;
}
.profile_slider__JVmwm .profile_card__XIV0V.profile_choosen__lUFuU p {
  color: #fff;
}
.profile_slider__JVmwm .profile_card__XIV0V .profile_head__dFSaH {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 16px;
}
.profile_slider__JVmwm .profile_card__XIV0V p {
  max-width: 85px;
  width: 100%;
  font-family: GteDisplayBold;
  white-space: wrap;
  word-wrap: break-word;
  color: #000000;
}

.profile_history__ojaUZ {
  background: #FAFAFA;
  width: 100%;
  border-radius: 20px;
  padding: 20px;
  margin-top: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.profile_history__ojaUZ div {
  display: flex;
  width: 100%;
  align-items: center;
  grid-gap: 12px;
}
.profile_history__ojaUZ div h4 {
  font-family: GteDisplayBold;
  font-size: 16px;
  color: #000;
}`, "",{"version":3,"sources":["webpack://./src/pages/profile/profile.module.scss"],"names":[],"mappings":"AAAA;EACE,6BAAA;EACA,+DAAA;EACA,kBAAA;EACA,mBAAA;AACF;AACA;EACE,8BAAA;EACA,+DAAA;EACA,kBAAA;EACA,mBAAA;AACF;AACA;EACE,8BAAA;EACA,kBAAA;EACA,+DAAA;EACA,mBAAA;AACF;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;AAAF;AACE;EACE,4BAAA;EACA,eAAA;EACA,cAAA;AACJ;;AAGA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAAF;AACE;EACE,aAAA;EACA,mBAAA;AACJ;AAAI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAEN;AAEE;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,aAAA;EACA,iBAAA;AAAJ;AAEI;EACE,2BAAA;EACA,eAAA;EACA,WAAA;AAAN;AAGI;EACE,cAAA;EACA,eAAA;EACA,4BAAA;AADN;;AAMA;EACE,gBAAA;AAHF;AAKE;EACE,2BAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;AAHJ;AAME;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;AAJJ;AAKI;EACE,8BAAA;AAHN;AAKM;EACE,WAAA;AAHR;AAOI;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,mBAAA;AALN;AAQI;EACE,eAAA;EACA,WAAA;EACA,2BAAA;EACA,iBAAA;EACA,qBAAA;EACA,cAAA;AANN;;AAWA;EACE,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AARF;AAUE;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA;AARJ;AAUI;EACE,2BAAA;EACA,eAAA;EACA,WAAA;AARN","sourcesContent":["@font-face {\r\n  font-family: \"GteDisplayBold\";\r\n  src: url('../../shared/font/gteestiprodisplay_regular.otf') format(\"truetype\");\r\n  font-style: normal;\r\n  font-weight: normal;\r\n}\r\n@font-face {\r\n  font-family: \"GteDisplayExtra\";\r\n  src: url('../../shared/font/gteestiprodisplay_bold.otf') format(\"truetype\");\r\n  font-style: normal;\r\n  font-weight: normal;\r\n}\r\n@font-face {\r\n  font-family: \"GteDisplayLight\";\r\n  font-style: normal;\r\n  src: url('../../shared/font/gteestiprodisplay_light.otf') format(\"truetype\");\r\n  font-weight: normal;\r\n}\r\n\r\n.header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-top: 60px;\r\n  h4 {\r\n    font-family: GteDisplayExtra;\r\n    font-size: 28px;\r\n    color: #000000;\r\n  }\r\n}\r\n\r\n.profile {\r\n  margin-top: 40px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  .left {\r\n    display: flex;\r\n    align-items: center;\r\n    img {\r\n      width: 60px;\r\n      height: 60px;\r\n      border-radius: 50%;\r\n    }\r\n  }\r\n  \r\n  .nameWrapper {\r\n    display: flex;\r\n    align-items: flex-start;\r\n    flex-direction: column;\r\n    grid-gap: 4px;\r\n    margin-left: 12px;\r\n\r\n    h4 {\r\n      font-family: GteDisplayBold;\r\n      font-size: 18px;\r\n      color: #000;\r\n    }\r\n\r\n    span {\r\n      color: #C2C2C2;\r\n      font-size: 16px;\r\n      font-family: GteDisplayLight;\r\n    }\r\n  }\r\n}\r\n\r\n.slider {\r\n  margin-top: 25px;\r\n\r\n  h4 {\r\n    font-family: GteDisplayBold;\r\n    font-size: 20px;\r\n    color: #000;\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  .card {\r\n    max-width: 104px;\r\n    width: 100%;\r\n    background: #FAFAFA;\r\n    height: 122px;\r\n    border-radius: 10px;\r\n    padding: 10px;\r\n    cursor: pointer;\r\n    &.choosen {\r\n      background: #9E4BFF !important;\r\n\r\n      p {\r\n        color: #fff;\r\n      }\r\n    }\r\n\r\n    .head {\r\n      display: flex;\r\n      align-items: flex-start;\r\n      justify-content: space-between;\r\n      margin-bottom: 16px;\r\n    }\r\n\r\n    p {\r\n      max-width: 85px;\r\n      width: 100%;\r\n      font-family: GteDisplayBold;\r\n      white-space: wrap;\r\n      word-wrap: break-word;\r\n      color: #000000;\r\n    }\r\n  }\r\n}\r\n\r\n.history {\r\n  background: #FAFAFA;\r\n  width: 100%;\r\n  border-radius: 20px;\r\n  padding: 20px;\r\n  margin-top: 24px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n\r\n  div {\r\n    display: flex;\r\n    width: 100%;\r\n    align-items: center;\r\n    grid-gap: 12px;\r\n\r\n    h4 {\r\n      font-family: GteDisplayBold;\r\n      font-size: 16px;\r\n      color: #000;\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `profile_header__h+b97`,
	"profile": `profile_profile__Evbmz`,
	"left": `profile_left__DlP-w`,
	"nameWrapper": `profile_nameWrapper__hN6iH`,
	"slider": `profile_slider__JVmwm`,
	"card": `profile_card__XIV0V`,
	"choosen": `profile_choosen__lUFuU`,
	"head": `profile_head__dFSaH`,
	"history": `profile_history__ojaUZ`
};
export default ___CSS_LOADER_EXPORT___;
